import sequenceReducers from '../sequenceReducers'
import auth from './auth'
import blog from './blog'
import dashboard from './dashboard'
import registration from './registration'
import user from './user'
import mymacrosplus from './mymacrosplus'
import timeline from './tracker/timeline'
import trackerViews from './tracker/tracker-views'
import badge from "./badge";
import friendList from './friend-list';
import friendAdd from './friend-add';
import friendTracker from './friend-tracker';
import resetProfile from './reset-profile'
import measurements from './measurements'

const reducersObject = {
  auth,
  blog,
  dashboard,
  mymacrosplus,
  registration,
  timeline,
  trackerViews,
  user,
  badge,
  friendList,
  friendAdd,
  friendTracker,
  resetProfile,
  measurements,
}

const sequence = [
  'auth',
  'blog',
  'dashboard',
  'mymacrosplus',
  'registration',
  'timeline',
  'trackerViews',
  'user',
  'badge',
  'friendList',
  'friendAdd',
  'friendTracker',
  'resetProfile',
  'measurements',
]

const reducers = sequenceReducers(reducersObject, sequence)

export default reducers
